import React from 'react';
import { Select } from '../../../../flayr-components';

interface ITimeConstraintInputProps {
  value?: string;
  onChange?: (e: any) => void;
}

const TimeConstraintInput: React.FC<React.PropsWithChildren<React.PropsWithChildren<ITimeConstraintInputProps>>> = ({
  value,
  onChange,
}) => {
  return (
    <div className="">
      <Select
        label="Would you like to change start or finish time?"
        size="lg"
        options={['start', 'finish']}
        name="timeConstraint"
        value={value}
        onChange={onChange}
      />
    </div>
  );
};
export default TimeConstraintInput;
